export function apiErrorText(error: unknown, fallback: string): string {
  const candidate = error as {
    message?: string;
    response?: { data?: { message?: string | string[]; error?: string } };
  };
  const responseMessage = candidate.response?.data?.message;
  if (Array.isArray(responseMessage)) {
    const useful = responseMessage.filter(isUsefulMessage);
    if (useful.length > 0) return useful.join('；');
  }
  if (typeof responseMessage === 'string' && isUsefulMessage(responseMessage)) {
    return responseMessage;
  }
  const responseError = candidate.response?.data?.error;
  if (typeof responseError === 'string' && isUsefulMessage(responseError)) {
    return responseError;
  }
  if (typeof candidate.message === 'string' && isUsefulMessage(candidate.message)) {
    return candidate.message;
  }
  return fallback;
}

function isUsefulMessage(value: string): boolean {
  const normalized = value.trim().toLowerCase();
  if (!normalized) return false;
  return !(
    normalized === 'internal server error' ||
    normalized === 'network error' ||
    /^request failed with status code \d{3}$/.test(normalized)
  );
}
